import ComponentImage from 'GeneralComponents/ComponentImage';
import CustomLinkButton from 'GeneralComponents/CustomLinkButton';
import contentShowItem from "MiniSiteComponents/Carousel/Carousel.interface";
import { ContentShowListProps as Props } from 'MiniSiteComponents/ContentShow/ContentShow.interface'
import Helper from 'Interfaces/Helper';
import "./SquareCollage.min.css";
import { decodeHtmlEntities } from '../../../Interfaces/utils/Utils';


const CollageList: React.FC<Props> = (props) => {

    const { componentId, dir, noImagesClass, items, CollageLayoutSize, linkTarget } = props;
    const COLLAGE_SIZES = Object.freeze({ LG: "תצוגה גדולה", SM: "תצוגה קטנה" });
    const isMiniCollage = CollageLayoutSize !== COLLAGE_SIZES.LG;
    //const maxItemsToRender = getCollageItemsCount(items);
    const collageBackgroundClasses = getCollageBackgroundIndexes(items);
    const itemsToRender = items;//.slice(0, maxItemsToRender);

    /*** the collage items has maximum of 9 and displayed in threes,
the func returns the number of items to render (0,3,6 or 9). */
    //function getCollageItemsCount(items: contentShowItem[]) {

    //    const numberOfAllItems = items.length;

    //    let itemsToRenderCount = numberOfAllItems - numberOfAllItems % 3;
    //    itemsToRenderCount = numberOfAllItems >= 9 ? 9 : itemsToRenderCount;

    //    return itemsToRenderCount;
    //};

    /* the collage has four different colors for backgrounds, displayed in order and should
skip images, the func returns array of classNames for the background colors of the items */
    function getCollageBackgroundIndexes(items: contentShowItem[]) {

        let currrentIndex = -1;

        return items.map((item) => {
            if (item.image.url) {
                return "bg-0";
            } else {
                currrentIndex++;
                return "bg-" + (currrentIndex % 4 + 1);
            }
        })
    }

    return <ul className={`mst-Square-Collage mx-auto d-flex flex-wrap 
        ${isMiniCollage ? 'mst-mini-collage' : ''} 
        ${noImagesClass}`}
        id={"mst-content-list-" + componentId} >

        {
            itemsToRender.map((contentShowItem, idx) => { 

                const hasImg = contentShowItem.image.url;

                return <li
                    key={contentShowItem.index}
                    className={"item " + collageBackgroundClasses[idx]}>

                    {
                        hasImg ?

                            <ComponentImage
                                image={contentShowItem.image}
                                mobileImage={contentShowItem.mobileImage}
                                imageClass="img-item"
                                wrapperDivClass="img-wrapper"
                                mobileImageClass="img-item"
                            />

                            :

                            <div className="detailes-container">
                                {
                                    contentShowItem.title &&
                                    <h3 className="title">{contentShowItem.title}</h3>
                                }
                                {
                                    contentShowItem.richDescription &&
                                    <span className="description">
                                        {Helper.CleanHtmlTags(decodeHtmlEntities(contentShowItem.richDescription))}
                                    </span>
                                }
                            </div>
                    }

                    {
                        (contentShowItem.link.url || contentShowItem.url) &&
                        <CustomLinkButton
                            link={contentShowItem.link}
                            isBtn={false}
                            linkClass="link"
                            pageUrl={contentShowItem.url}
                            title={contentShowItem.title}
                            linkTarget={linkTarget}
                        />
                    }

                    {
                        (contentShowItem.link.url || contentShowItem.url) &&

                        <div className={`txt-pallete-color arrow-icon-wrapper 
                                arrow-wrapper-${dir === "rtl" ? "left" : "right"}`}>
                            <i className={`fa-arrow-${dir === "rtl" ? "left" : "right"}`}></i>
                        </div>
                    }
                </li>

            })
        }


    </ul>
}

export default CollageList;